import { useRef } from "react";

export function useDebounce<FuncProps extends unknown[]>(
    delay: number,
    func: (...props: FuncProps) => void,
    maxDelay: number = Infinity,
) {
    const timeout = useRef<number | undefined>(undefined);
    const lastCallTime = useRef<number>(0);

    const debounced = (...props: FuncProps) => {
        clearTimeout(timeout.current);
        const timeSinceLastCall = Date.now() - lastCallTime.current;
        if (timeSinceLastCall >= maxDelay) {
            lastCallTime.current = Date.now();
            func(...props);
            return;
        }
        timeout.current = window.setTimeout(() => {
            lastCallTime.current = Date.now();
            func(...props);
        }, delay);
    };

    debounced.cancel = () => clearTimeout(timeout.current);

    return debounced;
}
